import React from 'react';
import { FaGlobe, FaLayerGroup, FaTags, FaUtensils } from 'react-icons/fa';
import SearchDropdown from '../../../../../../../../../../components/common/SearchDropdown/SearchDropdown';
import './CouponReach.scss';

interface CouponReachProps {
  applyOn: string;
  setApplyOn: (val: string) => void;
  menuOptions: any[];
  categoryOptions: any[];
  itemOptions: any[];
  menuId: string;
  setMenuId: (id: string) => void;
  categoryId: string;
  setCategoryId: (id: string) => void;
  itemId: string;
  setItemId: (id: string) => void;
  setIsGlobal: (val: boolean) => void;
  showAlcanceExplanation: string;
  setShowAlcanceExplanation: (val: string) => void;
  selectedCategory: any;
  selectedItem: any;
  disabled?: boolean;
}

const CouponReach: React.FC<CouponReachProps> = ({
  applyOn,
  setApplyOn,
  menuOptions,
  categoryOptions,
  itemOptions,
  menuId,
  setMenuId,
  categoryId,
  setCategoryId,
  itemId,
  setItemId,
  setIsGlobal,
  showAlcanceExplanation,
  setShowAlcanceExplanation,
  selectedCategory,
  selectedItem,
  disabled = false
}) => {
  return (
    <div className="form-section apply-section coupon-reach-section">
      <div className="section-title">
        <FaGlobe className="section-icon" />
        Alcance del cupón
      </div>

      {showAlcanceExplanation && (
        <div className="alcance-explanation-banner">
          <div className="explanation-content">
            {showAlcanceExplanation === 'Global' && 'Se aplica a toda la compra del cliente'}
            {showAlcanceExplanation === 'Menú' && 'Solo se aplica a un menú en particular'}
            {showAlcanceExplanation === 'Categoría' && 'Solo para productos de una categoría específica'}
            {showAlcanceExplanation === 'Item' && 'Solo para un producto en particular'}
          </div>
          <button
            className="close-explanation"
            onClick={() => setShowAlcanceExplanation('')}
          >
            ×
          </button>
        </div>
      )}

      <div className="apply-options single-row">
        <div
          className={`apply-option compact ${applyOn === 'Global' ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => {
            if (disabled) return;
            setApplyOn('Global');
            setIsGlobal(true);
            setCategoryId('');
            setMenuId('');
            setItemId('');
            setShowAlcanceExplanation(showAlcanceExplanation === 'Global' ? '' : 'Global');
          }}
        >
          <div className="apply-icon"><FaGlobe /></div>
          <div className="apply-title">Global</div>
        </div>

        {menuOptions && menuOptions.length > 1 && (
          <div
            className={`apply-option compact ${applyOn === 'Menú' ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => {
              if (disabled) return;
              setApplyOn('Menú');
              setIsGlobal(false);
              setCategoryId('');
              setItemId('');
              if (menuOptions.length > 0 && !menuId) {
                setMenuId(menuOptions[0].id);
              }
              setShowAlcanceExplanation(showAlcanceExplanation === 'Menú' ? '' : 'Menú');
            }}
          >
            <div className="apply-icon"><FaLayerGroup /></div>
            <div className="apply-title">Menú</div>
          </div>
        )}

        <div
          className={`apply-option compact ${applyOn === 'Categoría' ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => {
            if (disabled) return;
            setApplyOn('Categoría');
            setIsGlobal(false);
            setMenuId('');
            setItemId('');
            setShowAlcanceExplanation(showAlcanceExplanation === 'Categoría' ? '' : 'Categoría');
          }}
        >
          <div className="apply-icon"><FaTags /></div>
            <div className="apply-title">Categoría</div>
        </div>

        <div
          className={`apply-option compact ${applyOn === 'Item' ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => {
            if (disabled) return;
            setApplyOn('Item');
            setIsGlobal(false);
            setMenuId('');
            setCategoryId('');
            setShowAlcanceExplanation(showAlcanceExplanation === 'Item' ? '' : 'Item');
          }}
        >
          <div className="apply-icon"><FaUtensils /></div>
          <div className="apply-title">Ítem</div>
        </div>
      </div>

      <div className="apply-selection">
        {applyOn === 'Menú' && menuOptions && menuOptions.length > 1 && (
          <div className="menu-selection">
            <div className="menu-list">
              {menuOptions.map((menu, index) => (
                <div
                  key={menu.id}
                  className={`menu-option ${menuId === menu.id || (index === 0 && !menuId) ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
                  onClick={() => {
                    if (disabled) return;
                    setMenuId(menu.id);
                  }}
                >
                  <div className="menu-name">{menu.name}</div>
                  {(index === 0 && !menuId) && <div className="default-badge">Por defecto</div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {applyOn === 'Categoría' && (
          <div className={`search-dropdown high-z-index ${disabled ? 'disabled' : ''}`}>
            <SearchDropdown
              items={categoryOptions}
              selected={selectedCategory}
              setSelected={(selectedCat: any) => {
                if (disabled) return;
                setCategoryId(selectedCat.id);
              }}
              displayProperty="name"
              idProperty="id"
              placeholder="Selecciona una categoría"
              dropdownClassName="mb-3 high-z-dropdown"
              disabled={disabled}
            />
          </div>
        )}

        {applyOn === 'Item' && (
          <div className={`search-dropdown high-z-index ${disabled ? 'disabled' : ''}`}>
            <SearchDropdown
              items={itemOptions}
              selected={selectedItem}
              setSelected={(selectedItm: any) => {
                if (disabled) return;
                setItemId(selectedItm.id);
              }}
              displayProperty="name"
              idProperty="id"
              placeholder="Selecciona un ítem"
              dropdownClassName="mb-3 high-z-dropdown"
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponReach;
